<template>
  <div class="user-detail-container">
    <div class="user-detail-top" v-if='this.user'>
      <div class="row">
        <div class="col-lg-3">
          <div class="detail-top-item">
            <div>
              <p v-if="this.user.mobilenumber">{{this. user.mobilenumber }}</p>
              <i class="sr sr-check-circle checked"></i>
            </div>
            <p v-if="this.user.lastname && this.user.firstname">
              {{ this.user.lastname }} {{ this.user.firstname }}
            </p>
          </div>
        </div>
        <div v-if="date && date.end_date" class="col-lg-3">
          <div class="detail-top-item">
            <div>
              <p>Арилжааны эрх дуусах огноо</p>
            </div>
            <p>{{ date.end_date | formatDate('dateTime') }}</p>
          </div>
        </div>
        <div class="col lg-6">
          <div class="detail-top-item-right">
            <div>
              <p style="color: rgb(var(--rgb-system-green))">
                {{ statusString }}
              </p>
            </div>
            <ic-button
                v-if="statusCode === 0 || statusCode === 3"
                @click="showModal()"
                type="button"
                size="tn"
                class="float-right mt-1"
            >Оруулах</ic-button
            >
          </div>
        </div>
      </div>
    </div>
    <div v-if='this.user' class="user-detail-body">
      <div class="row" v-if="this.ids && this.ids.length > 0">
        <div  v-for="(item, i) in this.ids" class="col">
          <id-card-view :img-id="item.id" :label="`${$t(getLabel(item.filename))}`" ></id-card-view>
        </div>
      </div>
      <div v-else>
        <id-card-view/>
      </div>
    </div>
    <ic-dialog :show="id_card_modal" style="overflow-y: scroll">
      <div class="dialog-box" :style="minimized ? 'margin-top: 400px' : ''">
        <div role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 v-if="this.user.individual !== 'child'" class="modal-title">
                Иргэний үнэмлэхний мэдээлэл оруулах
              </h5>
              <h5 v-else class="modal-title">
                Төрсний гэрчилгээний мэдээлэл оруулах
              </h5>
              <button
                  type="button"
                  class="close"
                  @click.stop="id_card_modal = false"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <id-card
                  :is-child="this.user.individual === 'child'"
                  :csrf="csrfToken"
              ></id-card>
            </div>
          </div>
        </div>
      </div>
    </ic-dialog>
  </div>
</template>

<script>
import IdCardView from "../../components/global/ImageInput/IdCardView.vue";
import IdCard from '../../components/Registration/IdCard'
import {getUserIds} from "../../api/user";
import {mapState} from "vuex";

export default {
  components: {IdCardView, IdCard},
  computed: {
    ...mapState('user', ['user', 'date', 'statusString', 'statusCode']),
    isChild() {
      return (this.user.individual === 'child' ||  this.user.individual === 'children');
    },
  },
  data() {
    return {
      ids: [],
      minimized: false,
      addIdCard: false,
      csrfToken: null,
      id_card_modal: false,
    }
  },
  created() {
    if (process.browser) {
      window.addEventListener('resize', this.handleWindowResize)
    }
  },
  mounted() {
    this.handleWindowResize()
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').content
    this.getIds();
  },
  methods: {
    async getIds() {
      try{
        const {data} = await getUserIds()
        this.ids = data;
      } catch (e) {
        console.error(e)
      }
    },
    showModal() {
      if (this.user) this.id_card_modal = true
      else this.$bvToast.show('Харилцагч олдсонгүй')
    },
    handleWindowResize() {
      this.windowWidth = window.innerWidth
      if (this.windowWidth <= 750) {
        this.minimized = true
      } else if (this.windowWidth >= 750) {
        this.minimized = false
      }
    },
    getLabel(fileName) {
      const labelVal = 'registration.';
      let suff = 'photo';
      if (fileName.includes('ids_front'))
        suff = (this.isChild ? 'front-bc' : 'front')
      if (fileName.includes('ids_back'))
        suff = (this.isChild ? 'back-bc' : 'back')
      if (fileName.includes('ids_selfie'))
        suff = (this.isChild ? 'selfie-bc' : 'selfie')
      if (fileName.includes('ids_signature'))
        suff =  'signature'
      if (fileName.includes('ids_disability_front'))
        suff =  'disability-front'
      if (fileName.includes('ids_disability_back'))
        suff =  'disability-back'
      return labelVal + suff
    }
  }
}
</script>
<style lang="scss" src="./UserDetail.scss"></style>